module.exports = __webpack_public_path__ + "static/media/sistemaPegar6.fc8b3db0.jpg";